import { IMenuResponse } from '../../../../model/apm/menu/response/menu-response';
import { IMenuItemResponse } from '../../../../model/apm/menu/response/menu-item-response';

export type MenuState = {
    menus: IMenuResponse[];
    loadingMenus: boolean;
    selectedMenuId?: number;
    items: IMenuItemResponse[];
    loadingItems: boolean;
    menuDrawer: { open: boolean; menu?: IMenuResponse };
    itemDrawer: { open: boolean; item?: IMenuItemResponse };
};

export enum ACTION_TYPES {
    setMenus = 'setMenus',
    setLoadingMenus = 'setLoadingMenus',
    selectMenu = 'selectMenu',
    setItems = 'setItems',
    setLoadingItems = 'setLoadingItems',
    openMenuDrawer = 'openMenuDrawer',
    closeMenuDrawer = 'closeMenuDrawer',
    openItemDrawer = 'openItemDrawer',
    closeItemDrawer = 'closeItemDrawer',
}

export const MenuReducer = (state: MenuState, action: any): MenuState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.setMenus:
            return { ...state, menus: payload };
        case ACTION_TYPES.setLoadingMenus:
            return { ...state, loadingMenus: payload };
        case ACTION_TYPES.selectMenu:
            return { ...state, selectedMenuId: payload, items: [] };
        case ACTION_TYPES.setItems:
            return { ...state, items: payload };
        case ACTION_TYPES.setLoadingItems:
            return { ...state, loadingItems: payload };
        case ACTION_TYPES.openMenuDrawer:
            return { ...state, menuDrawer: { open: true, menu: payload } };
        case ACTION_TYPES.closeMenuDrawer:
            return { ...state, menuDrawer: { open: false } };
        case ACTION_TYPES.openItemDrawer:
            return { ...state, itemDrawer: { open: true, item: payload } };
        case ACTION_TYPES.closeItemDrawer:
            return { ...state, itemDrawer: { open: false } };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
};
